import React, { useEffect, useState } from "react";
import Header from "./Header";
import "bootstrap/dist/css/bootstrap.min.css";
import host from "../config";
import { FaEdit } from "react-icons/fa";

const BlockedData = () => {
  const [blockedRooms, setBlockedRooms] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const roomsPerPage = 20;

  let userRole = localStorage.getItem("userRole");
  userRole = userRole ? parseInt(userRole, 10) : null; //
  const [filters, setFilters] = useState({
    eventDate: "",
    bookingDate: "",
    locationName: "",
    venueName: "",
  });

  useEffect(() => {
    fetch(`${host}/getBlockedRoomDetails`)
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data); // Debugging
        setBlockedRooms(data.data || []); // Ensure it's always an array
      })
      .catch((error) => {
        console.error("Error fetching blocked rooms:", error);
        setBlockedRooms([]); // Prevent undefined errors
      });
  }, []);

  const handleUnblock = async (room) => {
    if (!window.confirm("Are you sure you want to unblock this room?")) return;

    const requestData = {
      room_id: room.room_id,
      location_id: room.location_id,
      calendar_date: room.calander_date, // Use as is
    };

    try {
      const response = await fetch(`${host}/unblockRooms`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (result.success) {
        alert("Room unblocked successfully!");
        setBlockedRooms((prevRooms) =>
          prevRooms.filter((r) => r.id !== room.id)
        );
      } else {
        alert("Failed to unblock room.");
      }
    } catch (error) {
      console.error("Error unblocking room:", error);
    }
  };

  const indexOfLastRoom = currentPage * roomsPerPage;
  const indexOfFirstRoom = indexOfLastRoom - roomsPerPage;
  // const currentRooms = (blockedRooms || []).slice(
  //   indexOfFirstRoom,
  //   indexOfLastRoom
  // );

  const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  // convert to local yyyy-MM-dd (not UTC!)
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

  const filteredRooms = blockedRooms.filter((room) => {
    // const eventDateMatch =
    //   !filters.eventDate || room.calander_date?.startsWith(filters.eventDate);
     const eventDateMatch =
    !filters.eventDate || formatDate(room.calander_date) === filters.eventDate;
    const bookingDateMatch =
      !filters.bookingDate || room.timestamp?.startsWith(filters.bookingDate);
    const locationMatch =
      !filters.locationName ||
      room.location_name
        ?.toLowerCase()
        .includes(filters.locationName.toLowerCase());
    const venueMatch =
      !filters.venueName ||
      room.room_name?.toLowerCase().includes(filters.venueName.toLowerCase());
    const blockedByMatch =
      !filters.blockedBy ||
      room.name?.toLowerCase().includes(filters.blockedBy.toLowerCase());

    return (
      eventDateMatch &&
      bookingDateMatch &&
      locationMatch &&
      venueMatch &&
      blockedByMatch
    );
  });

  const currentRooms = filteredRooms.slice(indexOfFirstRoom, indexOfLastRoom);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

const formatDisplayDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" }); // e.g. 'Oct'
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};



  return (
    <>
      <Header />
      <div className="container mt-4">
        <h2 className="text-center mb-4">Blocked Room Details</h2>
        <div className="row">
          <div className="row mb-3">
            <div className="col-md-3">
              <label>Event Date:</label>
              <input
                type="date"
                className="form-control"
                placeholder="Event Date"
                value={filters.eventDate}
                onChange={(e) =>
                  setFilters({ ...filters, eventDate: e.target.value })
                }
              />
            </div>
            <div className="col-md-3">
              <label>Booking Date:</label>
              <input
                type="date"
                className="form-control"
                placeholder="Booking Date"
                value={filters.bookingDate}
                onChange={(e) =>
                  setFilters({ ...filters, bookingDate: e.target.value })
                }
              />
            </div>
            <div className="col-md-3">
              <label>Location Name:</label>
              <input
                type="text"
                className="form-control"
                placeholder="Location Name"
                value={filters.locationName}
                onChange={(e) =>
                  setFilters({ ...filters, locationName: e.target.value })
                }
              />
            </div>
            <div className="col-md-3">
              <label>Venue Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Venue Name"
                value={filters.venueName}
                onChange={(e) =>
                  setFilters({ ...filters, venueName: e.target.value })
                }
              />
            </div>
          </div>

          <div className="col-12">
            <table className="table table-striped table-hover">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Venue Name</th>
                  <th>Location Name</th>
                  <th>Blocked By</th>
                  <th>Block Reason</th>
                  <th>Event Date</th>
                  <th>Attachment</th>
                  <th>Booking Date</th>
                  {/* <th>Unblock</th> */}
                  {(userRole === 2 || userRole === 4) && <th>Unblock</th>}
                </tr>
              </thead>
              <tbody style={{ textAlignLast: "center" }}>
                {Array.isArray(blockedRooms) && blockedRooms.length > 0 ? (
                  currentRooms.map((room, index) => (
                    <tr key={room.id}>
                      <td>{indexOfFirstRoom + index + 1}</td>
                      <td>{room.room_name}</td>
                      <td>{room.location_name}</td>
                      <td>{room.name}</td>
                      <td>{room.blocked_reason || "N/A"}</td>
                      <td>
                        {/* {new Date(room.calander_date).toLocaleDateString()} */}
                        {formatDisplayDate(room.calander_date)}

                      </td>

                      
                      <td>
                        {room.attachment_url ? (
                          <a
                            href={room.attachment_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View
                          </a>
                        ) : (
                          "No Attachment"
                        )}
                      </td>
                      {/* <td>{room.timestamp?.substring(0, 10)}</td> */}
                      <td>{formatDisplayDate(room.timestamp)}</td>

                      {/* <td>
                        {room.is_blocked ? (
                          <FaEdit
                            onClick={() => handleUnblock(room)}
                            className="text-primary cursor-pointer"
                            title="Unblock Room"
                            style={{ cursor: "pointer" }}
                          />
                        ) : (
                          "-"
                        )}
                      </td> */}
                      {(userRole === 2 || userRole === 4) && (
                        <td>
                          {room.is_blocked ? (
                            <FaEdit
                              onClick={() => handleUnblock(room)}
                              className="text-primary cursor-pointer"
                              title="Unblock Room"
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            "-"
                          )}
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      No Blocked Rooms Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* Pagination */}
            {/* {blockedRooms.length > 0 && (
              <nav>
                <ul className="pagination justify-content-center">
                  {Array.from(
                    { length: Math.ceil(blockedRooms.length / roomsPerPage) },
                    (_, index) => (
                      <li
                        key={index}
                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    )
                  )}
                </ul>
              </nav>
            )} */}
            {filteredRooms.length > 0 && (
              <nav>
                <ul className="pagination justify-content-center">
                  {Array.from(
                    { length: Math.ceil(filteredRooms.length / roomsPerPage) },
                    (_, index) => (
                      <li
                        key={index}
                        className={`page-item ${
                          currentPage === index + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      </li>
                    )
                  )}
                </ul>
              </nav>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockedData;
